import React from "react"
import { blogData } from "../../../App"
import './blogpost.css'
import { firebaseServices } from "../../../../firebase/firebase"
import { useEffect } from "react"
import { useState } from "react"
import Skeleton from '@material-ui/lab/Skeleton';
const fburls = firebaseServices.dlurls
  
  const emptyblogData: blogData = {
      id: 0,
      title: '',
      summary: '',
      content: '',
    }

  const emptyData = {
    date: '',
    data: emptyblogData,
  }

  

const BlogPost = (props: any) => {
    const { loading, contents } = props;
    const [blogpost, setBlogPost] = React.useState(emptyData)
    const [url, setUrl] = useState('')
    useEffect(() => {
      fburls.img.then((url: any) => setUrl(url))
      contents.map((post: any) => 
        (post.data.id === parseInt(window.location.search.slice(1)))
        && setBlogPost(post)
      );
      console.log(`here is our date for the post ${blogpost.date}`)
    })
    return (
        <div className={'blog-post'}>
          <div className={'blog-wrapper'}>
            {url === '' ? <Skeleton style={{marginTop: -150}} width={640} height={640} /> : <img className={'blog-img'} src={url} alt={'perfected web-apps reactive-solutions'} />}
            <div className={'content-wrapper-blog'}>
                <div className="blog-header">
                  <h1>{loading ? <Skeleton style={{marginTop: -150}} width={640} height={320} /> : blogpost.data.title}</h1>
                  <p><i>Updated on {blogpost.date.slice(0, 10)}</i></p>
                </div>
                <div 
                id="dangerouslyInsertHere" 
                className={'blog-content'}
                dangerouslySetInnerHTML={{__html: blogpost.data.content}}
                >
                </div>
            </div>
          </div>
        </div>
        );    
}
export default BlogPost;